<template>
  <van-tabbar route active-color="#c061fe" inactive-color="#000">
    <van-tabbar-item replace to="/">
      <span>购课商城</span>
      <img slot="icon" slot-scope="props" :src="props.active ? require('@/assets/icons/home_active.png') : require('@/assets/icons/home.png')" />
    </van-tabbar-item>
    <van-tabbar-item replace to="/classroom">
      <span>我的课堂</span>
      <img slot="icon" slot-scope="props" :src="props.active ? require('@/assets/icons/classroom_active.png') : require('@/assets/icons/classroom.png')" />
    </van-tabbar-item>
    <van-tabbar-item v-if="!isDistributor" replace to="/profit">
      <span>赚奖学金</span>
      <img slot="icon" slot-scope="props" :src="props.active ? require('@/assets/icons/profit_active.png') : require('@/assets/icons/profit.png')" />
    </van-tabbar-item>
    <van-tabbar-item v-if="isDistributor" replace to="/distributor">
      <span>课程分销</span>
      <img slot="icon" slot-scope="props" :src="props.active ? require('@/assets/icons/distributor_active.png') : require('@/assets/icons/distributor.png')" />
    </van-tabbar-item>
    <van-tabbar-item replace to="/my">
      <span>个人中心</span>
      <img slot="icon" slot-scope="props" :src="props.active ? require('@/assets/icons/my_active.png') : require('@/assets/icons/my.png')" />
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  name: 'Tabbar',
  props: {
    isDistributor: Boolean
  }
}
</script>

<style lang="scss" scoped>

</style>
